import {css} from "@panda/css";

import {ThumbDownIcon, ThumbUpIcon} from "@pg-design/icons-module";

import {usePropertyVote} from "../../hooks/use_property_vote";

interface IProps {
    id: number;
    apiMessageIndex: number;
}

export const SemanticSearchConversationVoteButtons = (props: IProps) => {
    const {id, apiMessageIndex} = props;

    const {currentVote, handleVote} = usePropertyVote(id, apiMessageIndex);

    return (
        <div className={likeDislikeButtonsWrap}>
            <button className={voteButton} onClick={() => handleVote("like")}>
                <ThumbUpIcon fill={currentVote === "like" ? "var(--colors-green)" : "currentColor"} wrapperSize="2.4" size="2.4" />
            </button>

            <button className={voteButton} onClick={() => handleVote("dislike")}>
                <ThumbDownIcon fill={currentVote === "dislike" ? "var(--colors-danger)" : "currentColor"} wrapperSize="2.4" size="2.4" />
            </button>
        </div>
    );
};

const likeDislikeButtonsWrap = css({
    display: "flex",
    gap: 1,
    mb: 1
});

const voteButton = css({
    minWidth: "24px",
    minHeight: "24px",
    px: 1,
    py: 0.5
});
import {css} from "@panda/css";

import {ThumbDownIcon, ThumbUpIcon} from "@pg-design/icons-module";

import {usePropertyVote} from "../../hooks/use_property_vote";

interface IProps {
    id: number;
    apiMessageIndex: number;
}

export const SemanticSearchConversationVoteButtons = (props: IProps) => {
    const {id, apiMessageIndex} = props;

    const {currentVote, handleVote} = usePropertyVote(id, apiMessageIndex);

    return (
        <div className={likeDislikeButtonsWrap}>
            <button className={voteButton} onClick={() => handleVote("like")}>
                <ThumbUpIcon fill={currentVote === "like" ? "var(--colors-green)" : "currentColor"} wrapperSize="2.4" size="2.4" />
            </button>

            <button className={voteButton} onClick={() => handleVote("dislike")}>
                <ThumbDownIcon fill={currentVote === "dislike" ? "var(--colors-danger)" : "currentColor"} wrapperSize="2.4" size="2.4" />
            </button>
        </div>
    );
};

const likeDislikeButtonsWrap = css({
    display: "flex",
    gap: 1,
    mb: 1
});

const voteButton = css({
    minWidth: "24px",
    minHeight: "24px",
    px: 1,
    py: 0.5
});
